import {createStore} from 'vuex'

export default createStore({
    state: {
        account: {},
        pay_type: ""
    },
    getters: {},
    mutations: {
        setPayType(state, type) {
            window.sessionStorage.setItem("pay_type", type)
            this.state.pay_type = type
        },
        getPayType() {
            this.state.pay_type = window.sessionStorage.getItem("pay_type")
        },
        setAccount(state, account) {
            window.sessionStorage.setItem("account", JSON.stringify(account))
            this.state.account = account
        },
        getAccount() {
            let account = window.sessionStorage.getItem("account")
            if (!account) this.state.account = {}
            else this.state.account = JSON.parse(account)
        },
        removeAccount() {
            window.sessionStorage.removeItem("account")
            this.state.account = {}
        }
    },
    actions: {},
    modules: {}
})
